import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=8e462c8e&scoped=true&lang=pug"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=8e462c8e&prod&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=8e462c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e462c8e",
  null
  
)

export default component.exports